module.exports = __webpack_public_path__ + "static/media/biogas.f8c0b1a6.jpg";